// Sliding puzzle page entry; the daily is one 4 by 4 picture puzzle per local date, the same for everyone.
import { SlidingGame } from "../sliding/ui"
import { fetchDaily, mountCalendar, pageDate, updateLabel } from "../lib/daily"

async function start(): Promise<void> {
  const board = document.getElementById("board")
  if (!board) return
  const game = board.dataset.dailyGame
  if (!game) {
    ;(window as unknown as { dtGame?: SlidingGame }).dtGame = new SlidingGame(board)
    return
  }
  const { date } = pageDate(board)
  updateLabel(date)
  const daily = await fetchDaily<{ seed: string; image: string }>(game, date)
  // Reserve: if a file is missing, every player still gets the same puzzle for that date.
  const seed = daily?.seed ?? `reserve:${game}:${date}`
  const image = daily?.image ?? board.dataset.image ?? "numbers"
  ;(window as unknown as { dtGame?: SlidingGame }).dtGame = new SlidingGame(board, { game, date, seed, image })
  mountCalendar(game, "/sliding-puzzle")
}

void start()
